import { defineMessages } from 'react-intl';
export default defineMessages({
  basket: {
    id: 'component.batchActions.basket',
    defaultMessage: 'Basket',
  },
});
